<a
  [routerLink]="link()"
  class="block-link card"
  [class.has--background]="imageUrl() && !videoUrl() && !text()"
  [class.no--background]="!imageUrl()"
  [class.has--intro-text]="text()"
  [class.has--link]="link() && !videoUrl() && !text()"
  [class.is--vlog]="videoUrl()"
  [class.is--blog]="text()"
  [ngClass]="'is--' + size()"
  #linkEl
>
  <article class="card__inner">
    @if (imageUrl() && !text()) {
      <figure class="card__figure">
        <img [src]="imageUrl()! | resize: 500 : 400 : imageAnchor()" [alt]="title()" />
        @if (videoUrl()) {
          <fstr-icon [anchor]="'icon-play'"></fstr-icon>
        }
      </figure>
    }
    <header class="card__header" [class.has--footer]="showTime() || dateObj()">
      <div>
        <h1 class="h6 card__title">{{ title() }}</h1>
        @if (subTitle()) {
          <h2 class="h6 type-body-xs mt-1 card__title text-primary">{{ subTitle() }}</h2>
        }
        @if (label()) {
          <span class="card__label label">{{ label() }}</span>
        }
      </div>

      <span class="button button-icon button-icon--primary button--xs">
        <fstr-icon anchor="icon-arrow-right"></fstr-icon>
      </span>
    </header>
    @if (text()) {
      <div class="card__content">
        @if (imageUrl() && text()) {
          <figure class="card__figure">
            <img [src]="imageUrl()! | resize: 500 : 400 : (imageAnchor() || 'middlecenter')" [alt]="title()" />
            @if (videoUrl()) {
              <fstr-icon [anchor]="'icon-play'"></fstr-icon>
            }
          </figure>
        }
        <p class="text-muted">{{ text() }}</p>
      </div>
    }
    @if (dateObj() || showTime()) {
      <footer class="card__footer">
        <!-- <button
        *ngIf="date && showDate"
        class="button button-with-icon"
        [ngClass]="{ 'button-with-icon--muted': !imageUrl, 'button-with-icon--light': imageUrl }"
        >
        <fstr-icon anchor="icon-calendar"></fstr-icon>
        <span>{{ date | date: 'd MMMM y' }}</span>
      </button> -->
        <!-- <button
      *ngIf="endDate && showDate"
      class="button button-with-icon"
      [ngClass]="{ 'button-with-icon--muted': !imageUrl, 'button-with-icon--light': imageUrl }"
      >
      <fstr-icon anchor="icon-calendar"></fstr-icon>
      <span>{{ endDate | date: 'd MMMM y' }}</span>
    </button> -->
        @if (dateObj(); as date) {
          @if ((date | date: 'dd MMMM yyyy') === (endDateObj() | date: 'dd MMMM yyyy') || !endDateObj() || endDateObj()! < date) {
            <span
              class="button button-with-icon"
              [ngClass]="{ 'button-with-icon--muted': !imageUrl(), 'button-with-icon--light': imageUrl() }"
            >
              <fstr-icon anchor="icon-calendar"></fstr-icon>
              <span>{{ date | date: 'dd MMMM yyyy' }}</span>
            </span>
          }
          @if (endDateObj(); as endDate) {
            @if ((date | date: 'dd MMMM yyyy') !== (endDate | date: 'dd MMMM yyyy') && endDate > date) {
              <span
                class="button button-with-icon"
                [ngClass]="{ 'button-with-icon--muted': !imageUrl(), 'button-with-icon--light': imageUrl() }"
              >
                <fstr-icon anchor="icon-calendar"></fstr-icon>
                <span>{{ date | date: 'dd' }} -&nbsp; {{ endDate | date: 'dd MMMM yyyy' }}</span>
              </span>
            }
          }
          @if (showTime()) {
            @if ((date | date: 'dd MMMM yyyy') === (endDateObj() | date: 'dd MMMM yyyy') || !endDateObj()) {
              <span
                class="button button-with-icon"
                [ngClass]="{ 'button-with-icon--muted': !imageUrl(), 'button-with-icon--light': imageUrl() }"
              >
                <fstr-icon anchor="icon-clock"></fstr-icon>
                <span>{{ date | date: 'HH:mm' }}</span>
                @if (endDateObj(); as endDate) {
                  @if (showTime() && (date | date: 'dd MMMM yyyy') === (endDate | date: 'dd MMMM yyyy')) {
                    <span>&nbsp;- {{ endDate | date: 'HH:mm' }}</span>
                  }
                }
              </span>
            }
          }
        }
        @if (author()) {
          <span
            class="button button-with-icon pointer-event-none"
            [ngClass]="{ 'button-with-icon--muted': !imageUrl(), 'button-with-icon--light': imageUrl() }"
          >
            <fstr-icon anchor="icon-author"></fstr-icon>
            <span>{{ author() }}</span>
          </span>
        }
      </footer>
    }
  </article>
</a>

<!-- <ng-container *ngIf="(contentType$ | async) === 'evenementen'">
<li
  class="header__meta__item"
              *ngIf="
                (page.publishDate && (page.publishDate | date: 'dd MMMM yyyy') === (page.endDate | date: 'dd MMMM yyyy')) ||
                page.endDate < page.publishDate
              "
  >
  <fstr-icon anchor="icon-calendar"></fstr-icon>
  {{ page.publishDate | date: 'dd MMMM yyyy' }}
</li>

<li
  class="header__meta__item"
  *ngIf="(page.publishDate | date: 'dd MMMM yyyy') !== (page.endDate | date: 'dd MMMM yyyy') && page.endDate > page.publishDate"
  >
  <fstr-icon anchor="icon-calendar"></fstr-icon>
  <span>{{ page.publishDate | date: 'dd' }} -&nbsp;</span>
  {{ page.endDate | date: 'dd MMMM yyyy' }}
</li>

<li class="header__meta__item" *ngIf="(page.publishDate | date: 'dd MMMM yyyy') === page.endDate | date: 'dd MMMM yyyy'">
  <fstr-icon anchor="icon-clock"></fstr-icon>
  <span>{{ page.publishDate | date: 'HH:mm' }}</span>
  <span *ngIf="page.endDate && (page.publishDate | date: 'dd MMMM yyyy') === (page.endDate | date: 'dd MMMM yyyy')">
    &nbsp;- {{ page.endDate | date: 'HH:mm' }}
  </span>
</li>
</ng-container> -->
